<template>
    <div class="box">
        <div class="box-header">
            <h3 class="box-title">Seznam osob</h3>
        </div>
        <div class="box-body">
            <div class="row">
                <div class="col-lg-4">
                    <div class="input-group input-group-sm" style="width: 100%">
                        <input v-model="filter" type="text" name="table_search" class="form-control" placeholder="Hledat">
                    </div>
                </div>
                <div class="col-lg-8">
                    <router-link :to="{ name: 'MaintainerAdd' }" class="btn btn-default btn-flat btn-sm pull-right"><i class="fa fa-plus"></i> Přidat osobu</router-link>
                </div>
            </div>
            <br>
            <div class="table-responsive no-padding" style="width: auto; overflow: auto">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th v-for="head in this.headColumns" :key="head.title">{{head.name}}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="maintainer in getMaintainers" :key="maintainer.maintainerid">
                            <td style="cursor: pointer" @click="makeCurrentMnt(maintainer.maintainerid)"><a>{{maintainer.fullname}}</a></td>
                            <td style="cursor: pointer" @click="makeCurrentCus(maintainer.customerid)"><a>{{maintainer.company_name}}</a></td>
                            <td v-if="maintainer.last_issueid" style="cursor: pointer" @click="makeCurrentIssue(maintainer.last_issueid)"><a>{{maintainer.last_issue}}</a></td>
                            <td v-else>{{maintainer.last_issue}}</td>
                            <td v-if="maintainer.next_issueid" style="cursor: pointer" @click="makeCurrentIssue(maintainer.next_issueid)"><a>{{maintainer.next_issue}}</a></td>
                            <td v-else>{{maintainer.next_issue}}</td>
                            <td>{{maintainer.email}}</td>
                            <td>{{maintainer.phone}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="!loaded" class="overlay">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
    </div>
</template>

<script>
const name = 'Maintainers';

import { mapGetters, mapActions } from "vuex";

export default {
    name,
    data() {
        return {
            filter: '',
            loaded: false,
        };
    },
    computed: {
        ...mapGetters(['getAllPages', 'allMaintainers', 'getCurrentPage']),
        getMaintainers() {
            var allMaintainers = this.allMaintainers

            if (!allMaintainers.length)
            {
                return []
            }
            
            // Filtr provedeme na vícero položkách auta -> možnost vyhledávání jak podle jména, tak podle VIN, atd..
            return allMaintainers.filter(item => {
                return (
                    this.$helpers.filterCheck(this.filter, item.company_name)
                    || this.$helpers.filterCheck(this.filter, item.fullname)
                    || this.$helpers.filterCheck(this.filter, item?.next_issue === undefined ? "" : item.next_issue)
                    || this.$helpers.filterCheck(this.filter, item?.last_issue === undefined ? "" : item.last_issue)
                );
            })
        }
    },
    methods: {
        ...mapActions([
            'makeActiveTab', 'addTab', 'fetchMaintainers', 
            'makeCurrentCus', 'makeCurrentMnt', 'makeCurrentIssue'
        ]),
    },
    created() {
        this.fetchMaintainers().then(() => {
            this.loaded = true;
        });

        // We put constants to created() method, putting them into data() would make them reactive (to state -> useless..)
        this.headColumns = [
            { name: 'Jméno' },
            { name: 'Zákazník' },
            { name: 'Poslední úkon' },
            { name: 'Následující úkon' },
            { name: 'Email' },
            { name: 'Telefon' }
        ]

        const page = this.getAllPages.filter(page => page.name == name)[0]   
        this.addTab(page);
        this.makeActiveTab(page);
    },
}
</script>